import { PASSWORD_VALIDATION } from './registrationConstants.ts';

export const validateEmail = (email: string): { isValid: boolean; error?: string } => {
  if (!email) {
    return { isValid: false, error: 'El email es obligatorio' };
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    return { isValid: false, error: 'Ingresa un email válido' };
  }

  return { isValid: true };
};

export const validatePassword = (password: string): { isValid: boolean; error?: string } => {
  if (!password) {
    return { isValid: false, error: 'La contraseña es obligatoria' };
  }

  if (password.length < PASSWORD_VALIDATION.MIN_LENGTH) {
    return { isValid: false, error: 'La contraseña debe tener al menos 8 caracteres entre letras y números' };
  }

  if (PASSWORD_VALIDATION.REQUIRE_LETTER) {
    const hasLetter = /[a-zA-Z]/.test(password);
    const hasNumber = /\d/.test(password);

    if (!hasLetter || !hasNumber) {
      return { isValid: false, error: 'La contraseña debe contener letras y números' };
    }
  }

  return { isValid: true };
};

export const validateConfirmPassword = (password: string, confirmPassword: string): { isValid: boolean; error?: string } => {
  if (!confirmPassword) {
    return { isValid: false, error: 'Confirma tu contraseña' };
  }

  if (confirmPassword !== password) {
    return { isValid: false, error: 'Las contraseñas no coinciden' };
  }

  return { isValid: true };
};

export const validateCode = (code: string): boolean => {
  return /^\d{6}$/.test(code);
};

export const parseJobboardPreRegisterSuccessResponse = (
  response: unknown
): {
  status?: string;
  role?: string;
  emailFromApi?: string;
  validated?: boolean;
  publicRoles?: string[];
} => {
  const r = response as { data?: Record<string, unknown> };
  const root = r?.data;
  const inner =
    root?.data != null && typeof root.data === "object" && !Array.isArray(root.data)
      ? (root.data as Record<string, unknown>)
      : root;
  const roleRaw = inner?.role;
  const publicRolesRaw = inner?.publicRols;
  const publicRoles = Array.isArray(publicRolesRaw)
    ? publicRolesRaw
        .filter((rol): rol is string => typeof rol === "string")
        .map((rol) => rol.toUpperCase())
    : [];
  const role =
    typeof roleRaw === "string"
      ? roleRaw.toUpperCase()
      : publicRoles.includes("JOBBOARD")
        ? "JOBBOARD"
        : publicRoles.includes("CLIENT")
          ? "CLIENT"
          : undefined;
  return {
    status: typeof inner?.status === "string" ? inner.status : undefined,
    role,
    emailFromApi: typeof inner?.email === "string" ? inner.email : undefined,
    validated: typeof inner?.validated === "boolean" ? inner.validated : undefined,
    publicRoles,
  };
};

export const isJobBoardLegacyUserNotFoundError = (error: any): boolean => {
  if (error?.response?.status !== 404) return false;
  const message = error?.response?.data?.message ?? "";
  if (typeof message !== "string") return false;
  const normalized = message.toLowerCase();
  return normalized.includes("job board") || normalized.includes("jobboard");
};

export const parsePreRegisterError = (error: any): {
  message: string;
  shouldRedirectToLogin?: boolean;
  isPreRegistered?: boolean;
  isAlreadyValidated?: boolean;
  isJobboardValidatedRegistered?: boolean;
} => {
  const originalMessage = error?.response?.data?.message || '';
  const responseData = error?.response?.data;
  const responseRoles = Array.isArray(responseData?.publicRols)
    ? responseData.publicRols
        .filter((r: unknown): r is string => typeof r === "string")
        .map((r: string) => r.toUpperCase())
    : [];
  const hasJobboardRole = responseRoles.includes("JOBBOARD");

  if (
    originalMessage === 'El usuario ya está registrado' &&
    responseData?.validated === true &&
    hasJobboardRole
  ) {
    return {
      message: 'Este email ya está validado. Podés ingresar con tu contraseña o crear una nueva para continuar.',
      isPreRegistered: true,
      isAlreadyValidated: true,
      isJobboardValidatedRegistered: true,
    };
  }

  if (originalMessage === 'El usuario ya está registrado' && responseData?.validated !== false) {
    return {
      message: 'Este email ya tiene una cuenta. Iniciá sesión para entrar.',
      shouldRedirectToLogin: true,
    };
  }

  if (originalMessage === 'El usuario ya está registrado' && responseData?.validated === false) {
    return {
      message: 'Recibimos tu registro antes, pero falta confirmar el email. Te guiamos en los pasos siguientes.',
      isPreRegistered: true,
    };
  }

  if (originalMessage.includes('pre-registrado') || originalMessage.includes('already pre-registered')) {
    if (responseData?.validated === true) {
      return {
        message: originalMessage,
        isPreRegistered: true,
        isAlreadyValidated: true,
      };
    } else {
      return {
        message: originalMessage,
        isPreRegistered: true,
      };
    }
  }

  return {
    message: originalMessage || 'Ocurrió un error. Intenta nuevamente.',
  };
};
